import { Link } from '@mui/icons-material';
import { Card, Grid, Switch, Typography } from '@mui/material';
import { ComponentTypes } from 'src/interfaces';
import { lang } from 'src/utils';

import { ThemeMarker } from '../CustomerTriggeredEventsPage.styled';
import {
  IScreenOption,
  IUpdateComponents,
  UnionGlobalComponent,
} from './ScreenConfigSection.interface';
import { ScreenConfigSelect } from './ScreenConfigSelect';

export const GlobalComponentPairedCard = ({
  components,
  screenOptions,
  handleCardChange,
  isViewOnly = false,
}: {
  components: UnionGlobalComponent[];
  screenOptions: IScreenOption[];
  handleCardChange: (updateComponents: IUpdateComponents[]) => void;
  isViewOnly?: boolean;
}) => {
  const handleScreenSequence = (value: number) => {
    const updateComponents = components.map((component) => ({
      componentType: component.componentType,
      componentVariant: component.componentVariant ?? '',
      updateValue: {
        screenSequence: value,
      },
    }));

    handleCardChange(updateComponents);
  };

  return (
    <Card variant="outlined" sx={{ borderRadius: '8px', marginBottom: 2 }}>
      <Grid container flexDirection={'column'} justifyContent={'space-between'}>
        <Grid
          container
          justifyContent={'space-between'}
          bgcolor={'#f9fafb'}
          padding={1}
          borderBottom={'1px solid #e5e7eb'}>
          <Grid
            item
            display={'flex'}
            alignSelf={'center'}
            alignItems={'center'}
            gap={2}>
            <Typography variant="body2" fontWeight={'bold'} marginLeft={3}>
              {lang.customerTriggeredEventsPage.pairedItems}
            </Typography>

            <Link />
          </Grid>

          <Grid item alignSelf={'center'} xs={4}>
            <ScreenConfigSelect
              label={lang.customerTriggeredEventsPage.screen}
              width="100px"
              value={components?.[0].screenSequence}
              onChange={(value) => handleScreenSequence(value as number)}
              options={screenOptions}
              disabled={isViewOnly}
            />
          </Grid>
        </Grid>

        {components.map((component, index) => (
          <Grid
            key={index}
            item
            width={'100%'}
            alignSelf={'center'}
            display={'flex'}
            alignItems={'center'}
            padding={1}>
            <Switch
              checked={!!component.enabled}
              disabled={
                isViewOnly || component.componentType === ComponentTypes.COD
              }
              onChange={() => {
                handleCardChange([
                  {
                    componentType: component.componentType,
                    componentVariant: component.componentVariant ?? '',
                    updateValue: {
                      enabled: !component.enabled,
                    },
                  },
                ]);
              }}
            />
            <ThemeMarker
              style={{ backgroundColor: component.color, marginRight: '8px' }}
            />
            <Typography variant="body2">{component.label}</Typography>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};
